/**
 * CapturePopup - Reveals captured member identity
 */

import { useEffect } from 'react';
import type { SquadMember } from '../../types';
import { POPUP_DURATION } from '../../types/pacman';
import { getInitials } from '../../utils';
import './CapturePopup.css';

interface CapturePopupProps {
  member: SquadMember;
  isLast: boolean;
  onDone: () => void;
}

export function CapturePopup({ member, isLast, onDone }: CapturePopupProps) {
  // Auto-dismiss after duration
  useEffect(() => {
    const timer = setTimeout(onDone, POPUP_DURATION);
    return () => clearTimeout(timer);
  }, [onDone]);

  // Skip on space
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.code === 'Space') {
        onDone();
      }
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [onDone]);

  const initials = getInitials(member.displayName);

  return (
    <div className="capture-popup-overlay">
      <div className="capture-popup">
        <div className="capture-popup__title">
          {isLast ? '🏆 LAST GHOST! 🏆' : '👻 CAPTURED!'}
        </div>

        <div className="capture-popup__avatar">
          <span className="capture-popup__initials">{initials}</span>
        </div>

        <div className="capture-popup__name">{member.displayName}</div>

        <div className="capture-popup__score">
          + {isLast ? '500' : '200'} pts
          {isLast && <span className="capture-popup__bonus">FINAL BONUS!</span>}
        </div>

        <div className="capture-popup__hint">[SPACE] continue</div>
      </div>
    </div>
  );
}
